import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "containers" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "area_title" }
const _hoisted_4 = { class: "area_button" }
const _hoisted_5 = { class: "area_body" }
const _hoisted_6 = { class: "area_section" }
const _hoisted_7 = { class: "area_table" }
const _hoisted_8 = { class: "area_table_head" }
const _hoisted_9 = { class: "select-wrap" }
const _hoisted_10 = { class: "total_length" }
const _hoisted_11 = { class: "area_table_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_ItemDetail = _resolveComponent("ItemDetail")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_ItemHistoryAdd = _resolveComponent("ItemHistoryAdd")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ItemDetail, {
        idx: $setup.state.idx,
        refreshFlag: $setup.state.refreshFlag,
        onCallback: _cache[0] || (_cache[0] = ($event: any) => ($setup.state.refreshFlag = false))
      }, null, 8, ["idx", "refreshFlag"]),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("p", null, "홍보물품이력", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showModal(null)))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("span", null, "입/출고", -1)
              ])),
              _createElementVNode("button", {
                type: "button",
                class: "",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args)))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("span", null, "일괄 삭제", -1)
              ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("select", {
                      name: "orderType",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.order) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.fnGetList(1)))
                    }, _cache[9] || (_cache[9] = [
                      _createElementVNode("option", { value: "0" }, "최근순", -1),
                      _createElementVNode("option", { value: "1" }, "과거순", -1)
                    ]), 544), [
                      [_vModelSelect, $setup.state.order]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($setup.CommonUtils.numberFormat($setup.pageState.length)) + " " + _toDisplayString(_ctx.$t("notice.count")), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_DataGrid, {
                    list: $setup.pageState.list,
                    columns: $setup.pageState.fields,
                    totalLength: $setup.pageState.length,
                    perPage: $setup.pageState.perPage,
                    cntPage: $setup.pageState.cntPage,
                    "current-page": $setup.pageState.currentPage,
                    isLoading: $setup.pageState.isLoading,
                    onOnRowClick: $setup.fnRowClick,
                    onOnPaging: $setup.fnGetList,
                    onOnNextPage: $setup.fnGoPage,
                    onOnPrevPage: $setup.fnGoPage,
                    onOnFirstPage: $setup.fnGoPage,
                    onOnLastPage: $setup.fnGoPage,
                    onAllClick: $setup.selectAll
                  }, null, 8, ["list", "columns", "totalLength", "perPage", "cntPage", "current-page", "isLoading", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage", "onAllClick"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowAddModal)
      ? (_openBlock(), _createBlock(_component_ItemHistoryAdd, {
          key: 0,
          data: $setup.state.data,
          onCallback: $setup.historyCallback,
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.state.isShowAddModal = false))
        }, null, 8, ["data", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callbackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}